// services/socketService.ts
import { io, Socket } from 'socket.io-client';

const SOCKET_URL = 'https://api.cryptmet.com/admin-panel';

let socket: Socket | null = null;

export const socketService = {
  connect(token: string) {
    if (socket?.connected) return socket;
    socket = io(SOCKET_URL, {
      auth: { token: `Bearer ${token}` },
      reconnectionAttempts: 5,
      transports: ['websocket', 'polling'],
    });
    socket.on('connect', () => console.log('[Socket] Connected'));
    socket.on('disconnect', () => console.log('[Socket] Disconnected'));
    socket.on('connect_error', (e) => console.error('[Socket] Error', e.message));
    return socket;
  },

  disconnect() {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
  },

  getSocket() {
    return socket;
  },

  // ─── Admin Profile ─────────────────────────────────────
  getAdminProfile(callback: (data: any) => void) {
    if (!socket) return;
    socket.emit('getAdminProfile');
    socket.on('adminProfileUpdate', callback);
  },

  // ─── Users All Details (real-time agent listing) ──────
  subscribeToUsersAllDetails(
    params: { page?: number; limit?: number; search?: string; parentId?: number },
    callback: (data: any) => void
  ) {
    if (!socket) return;
    socket.emit('getUsersAllDetails', params);
    socket.on('usersAllDetailsUpdate', callback);
  },

  unsubscribeFromUsersAllDetails() {
    if (!socket) return;
    socket.emit('stopUsersAllDetails');
    socket.off('usersAllDetailsUpdate');
  },
};
